import { render, staticRenderFns } from "./CategoriesInsights.vue?vue&type=template&id=592bded5&scoped=true&"
import script from "./CategoriesInsights.vue?vue&type=script&lang=js&"
export * from "./CategoriesInsights.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesInsights.vue?vue&type=style&index=0&id=592bded5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592bded5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
